import clsx from 'clsx';
import { Body, Chip } from 'copilot-design-system';
import React from 'react';
import { DateSeparatorProps } from 'stream-chat-react';

import { RowDivider } from 'src/components/RowDivider';
import { useMessagingTheme } from 'src/features/messages/messagingThemeContext';
import DateUtils from 'src/utils/DateUtils';

const DATE_FORMAT = 'dddd[,] MMM DD';
export const NewDateSeparator: React.FC<DateSeparatorProps> = React.memo(
  ({ date, unread }) => {
    const { isSidebarTheme } = useMessagingTheme();
    const when = React.useMemo(
      () =>
        DateUtils.humanizeDate(date.toISOString(), {
          sameDay: DATE_FORMAT,
          nextDay: DATE_FORMAT,
          nextWeek: DATE_FORMAT,
          lastDay: DATE_FORMAT,
          lastWeek: DATE_FORMAT,
        }),
      [date],
    );
    return (
      <div className="sticky top-0 z-10 flex justify-center my-3">
        <Chip
          label={unread ? `New - ${when}` : when}
          variant="outlined"
          className={clsx(
            isSidebarTheme && 'bg-gray-100 border-non-hover-border',
          )}
        />
      </div>
    );
  },
);
export const CustomDateSeparator: React.FC<DateSeparatorProps> = React.memo(
  ({ date, unread }) => {
    const when = React.useMemo(
      () =>
        DateUtils.humanizeDate(date.toISOString(), {
          lastWeek: 'ddd h:mm A',
          sameElse: 'MMM DD, YYYY, h:mm A',
        }),
      [date],
    );

    return (
      <RowDivider className="my-3" colorClassName="bg-secondary-hover">
        <Body className="whitespace-nowrap text-center text-[15px] text-gray-small">
          {unread ? `New - ${when}` : when}
        </Body>
      </RowDivider>
    );
  },
);
